<template>
  <footer class="footer">
    <!-- <img src="https://www.shinseibank.com/common09/imgs/popup_footer_line.jpg" alt=""> -->
    <div class="footer__fluid">
      <div class="footer__hr pc-visible"></div>

      <p class="footer__container footer__copy-right">
        <span>
          {{ $t('footer.lblAddr') }}
        </span>
        <span>
          {{ $t('footer.lblCopyright') }}
        </span>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {},
  created() {
    this.$i18n.locale = ['ja', 'en'].includes(this.$route.query.lang) ? this.$route.query.lang : 'ja'
  }
}
</script>
<style>
.footer {
  font-size:0.5em;
}
</style>
